/* eslint-disable react/forbid-prop-types */
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { Card } from './styles';

import NoData from '../../../../../components/NoData';
import download from '../../../../../assets/images/icons/download.svg';
import { useAppContext } from '../../../../../contexts/auth';
import DashboardService from '../../../../../services/affreightment/DashboardService';
import ExportXlsx from '../../../../../utils/ExportXlsx';
import formatDate from '../../../../../utils/formatDate';
import useApiCall from '../../../../../hooks/useApiCall';
import { AffreightmentRelResponse, OfferType } from '../../types';

interface OfferCardInterface {
  dashboardOfferData: OfferType;
  selectedWorkplace: { value: number, label: string };
}

export default function OfferCard({ dashboardOfferData, selectedWorkplace }: OfferCardInterface) {
  const today = new Date();
  today.setHours(today.getHours() - 3);
  const todayFormatted = today.toJSON().slice(0, 10);

  const { userData, selectedCompany } = useAppContext();
  const { userCode, userProfile } = userData;
  const companyCode = selectedCompany.value;
  const { apiCall } = useApiCall();

  const downloadRel = useCallback(async () => {
    await toast.promise(apiCall({
      apiToCall: DashboardService.getRelsData,
      queryParams: { codUsu: userCode, perfilUsu: userProfile, codEmpresa: companyCode },
      reqBody: JSON.stringify({
        codViagem: 0,
        codRelatorio: 4,
        dataViagens: todayFormatted,
        mes: todayFormatted.split('-')[1],
        ano: todayFormatted.split('-')[0],
        dataPesquisa: todayFormatted,
      }),
      actionAfterResponse: (response: AffreightmentRelResponse) => {
        if (response.oferta) {
          const ofertaRelData = response.oferta.map((data) => ({
            'Local | Turno': data.localDescr,
            CPF: data.cpf,
            Nome: data.nome,
            'Linha ida titular': data.linhaIda || 'Não foi identificada nenhuma linha',

            'Data ultimo embarque (linha ida)': (data.ultimoAcessoIda == '0001-01-01T00:00:00'
              ? 'Não foi identificado nenhum embarque'
              : formatDate(data.ultimoAcessoIda)),

            'Linha volta titular': data.linhaVolta || 'Não foi identificada nenhuma linha',

            'Data ultimo embarque (linha volta)': (data.ultimoAcessoVolta == '0001-01-01T00:00:00'
              ? 'Não foi identificado nenhum embarque'
              : formatDate(data.ultimoAcessoVolta)),
          }));
          ExportXlsx({
            data: ofertaRelData,
            filename: `Relatório oferta titulares ${formatDate(todayFormatted)}`,
          });
        }

        if (!response.oferta) {
          toast.error('Não há dados para serem baixados');
        }
      },
      catchMessage: 'Não foi possível baixar o relatório de usuários de VT',
    }), {
      pending: 'Sua planilha está sendo baixada',
      success: 'Sua planilha foi baixada!',
      error: 'Não foi possível baixar sua planilha',
    });
  }, [apiCall, userCode, userProfile, companyCode, todayFormatted]);

  return (
    <>
      <Card>
        <div className="card-title">
          <div>Oferta</div>
          <img src={download} alt="download" title="Baixar relatório excel" onClick={downloadRel} />
        </div>

        {dashboardOfferData && (
          <>
            <div className="card-main">
              <div>
                {dashboardOfferData.totFuncs}
                {' '}
              /
                {' '}
                {dashboardOfferData.totLugares}
              </div>
              <small>
                {(dashboardOfferData.totFuncs > 1 ? 'Lugares ocupados' : 'Lugar ocupado')}
              </small>
            </div>

            <footer>
              {(dashboardOfferData.percentual > 0) && (
                <>
                  <div className="porcentagem-positiva">
                +
                    {' '}
                    {dashboardOfferData.percentual}
                %
                  </div>
                  <div>
                Em relação ao início da operação
                  </div>
                </>
              )}
              {(dashboardOfferData.percentual < 0) && (
                <>
                  <div className="porcentagem-negativa">
                -
                    {' '}
                    {dashboardOfferData.percentual}
                %
                  </div>
                  <div>
                Em relação ao início da operação
                  </div>
                </>
              )}
            </footer>
          </>
        )}

        {(!dashboardOfferData) && (
          <NoData
            icon="emptyBox"
            label={(
              <>
              O local de trabalho
                {' '}
                <strong>{selectedWorkplace.label}</strong>
                {' '}
              não possui dados de oferta.
              </>
            )}
          />
        )}
      </Card>
    </>
  );
}
